import i18n from 'i18n/config';

const tt = (key, defaultValue) => i18n.t(key, { defaultValue });

export const firmwareDeploymentConstants = {
  GET_FIRMWARE_DEPLOYMENT_REQUEST: 'GET_FIRMWARE_DEPLOYMENT_REQUEST',
  GET_FIRMWARE_DEPLOYMENT_SUCCESS: 'GET_FIRMWARE_DEPLOYMENT_SUCCESS',
  GET_FIRMWARE_DEPLOYMENT_FAILURE: 'GET_FIRMWARE_DEPLOYMENT_FAILURE',
  SET_FIRMWARE_DEPLOYMENT_FILTERS: 'SET_FIRMWARE_DEPLOYMENT_FILTERS',
  CLEAR_FIRMWARE_DEPLOYMENT_LIST: 'CLEAR_FIRMWARE_DEPLOYMENT_LIST',

  GET_FIRMWARES_REQUEST: 'GET_FIRMWARES_REQUEST',
  GET_FIRMWARES_SUCCESS: 'GET_FIRMWARES_SUCCESS',
  GET_FIRMWARES_FAILURE: 'GET_FIRMWARES_FAILURE',

  GET_FIRMWARE_DEPLOYMENT_DETAILS_REQUEST: 'GET_FIRMWARE_DEPLOYMENT_DETAILS_REQUEST',
  GET_FIRMWARE_DEPLOYMENT_DETAILS_SUCCESS: 'GET_FIRMWARE_DEPLOYMENT_DETAILS_SUCCESS',
  GET_FIRMWARE_DEPLOYMENT_DETAILS_FAILURE: 'GET_FIRMWARE_DEPLOYMENT_DETAILS_FAILURE',

  GET_FIRMWARE_DEPLOYMENT_AFFECTED_DEVICES_REQUEST: 'GET_FIRMWARE_DEPLOYMENT_AFFECTED_DEVICES_REQUEST',
  GET_FIRMWARE_DEPLOYMENT_AFFECTED_DEVICES_SUCCESS: 'GET_FIRMWARE_DEPLOYMENT_AFFECTED_DEVICES_SUCCESS',
  GET_FIRMWARE_DEPLOYMENT_AFFECTED_DEVICES_FAILURE: 'GET_FIRMWARE_DEPLOYMENT_AFFECTED_DEVICES_FAILURE',

  RETRY_FIRMWARE_DEPLOYMENT_DEVICES_REQUEST: 'RETRY_FIRMWARE_DEPLOYMENT_DEVICES_REQUEST',
  RETRY_FIRMWARE_DEPLOYMENT_DEVICES_SUCCESS: 'RETRY_FIRMWARE_DEPLOYMENT_DEVICES_SUCCESS',
  RETRY_FIRMWARE_DEPLOYMENT_DEVICES_FAILURE: 'RETRY_FIRMWARE_DEPLOYMENT_DEVICES_FAILURE',

  GET_ALL_TX_SERIALS_REQUEST: 'GET_ALL_TX_SERIALS_REQUEST',
  GET_ALL_TX_SERIALS_SUCCESS: 'GET_ALL_TX_SERIALS_SUCCESS',
  GET_ALL_TX_SERIALS_FAILURE: 'GET_ALL_TX_SERIALS_FAILURE',

  GET_ALL_MOTE_SERIALS_REQUEST: 'GET_ALL_MOTE_SERIALS_REQUEST',
  GET_ALL_MOTE_SERIALS_SUCCESS: 'GET_ALL_MOTE_SERIALS_SUCCESS',
  GET_ALL_MOTE_SERIALS_FAILURE: 'GET_ALL_MOTE_SERIALS_FAILURE',

  NUMBER_OF_FIRMWARE_DEPLOYMENTS_PER_PAGE: 50,

  INCREASE_FIRMWARE_DEPLOYMENT_PAGE: 'INCREASE_FIRMWARE_DEPLOYMENT_PAGE',

  DEVICE_TYPE_MOTE: 'mote',
  DEVICE_TYPE_TRANSMITTER: 'tx',
  SENSOR_MODEL_RX: 'RX',
  SENSOR_MODEL_TX: 'TX',
  MOTE_MODEL_VERSION: '0901',
  TX_MODEL_VERSION: '0805',
};

export const getDeviceTypes = (t = i18n.t.bind(i18n)) => ([
  { value: 'tx', text: t('firmwareDeployment.deviceType.transmitter', { defaultValue: 'Transmitter' }) },
  { value: 'mote', text: t('firmwareDeployment.deviceType.mote', { defaultValue: 'Mote' }) }
]);

export const DEVICE_TYPES = getDeviceTypes();

export const getFirmwareTypes = (t = i18n.t.bind(i18n)) => ([
  { value: 'mcu', text: t('firmwareDeployment.firmwareType.mcu', { defaultValue: 'MCU' }) },
  { value: 'bluetooth', text: t('firmwareDeployment.firmwareType.bluetooth', { defaultValue: 'Bluetooth' }) },
  { value: 'bootloader', text: t('firmwareDeployment.firmwareType.bootloader', { defaultValue: 'Bootloader' }) }
]);

export const FIRMWARE_TYPES = getFirmwareTypes();

export const getAssociationTypes = (t = i18n.t.bind(i18n)) => ([
  { value: 'devices', text: t('firmwareDeployment.associationType.devices', { defaultValue: 'Devices' }) },
  { value: 'accounts', text: t('firmwareDeployment.associationType.accounts', { defaultValue: 'Accounts' }) },
  { value: 'firmwares', text: t('firmwareDeployment.associationType.firmwares', { defaultValue: 'Firmwares' }) },
]);

export const ASSOCIATION_TYPES = getAssociationTypes();
